import { render } from "./AllSegmentGroupsRevenue.vue?vue&type=template&id=7bc361a2&scoped=true"
import script from "./AllSegmentGroupsRevenue.vue?vue&type=script&lang=js"
export * from "./AllSegmentGroupsRevenue.vue?vue&type=script&lang=js"

import "./AllSegmentGroupsRevenue.vue?vue&type=style&index=0&id=7bc361a2&lang=scss&scoped=true"
import "./AllSegmentGroupsRevenue.vue?vue&type=style&index=1&id=7bc361a2&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bc361a2"]])

export default __exports__